



































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiFadeTransition from "@/components/common/AsiFadeTransition.vue";

@Component({
	components: {AsiFadeTransition, AsiBtn}
})
export default class AsiToolbar extends Vue {

	@Prop({type: String, default: null})
	public title!: string | null;

	@Prop({type: String, default: null})
	public icon!: string | null;

	@Prop({type: Boolean, default: false})
	public showExpanderToggleButton!: boolean;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	protected expanded: boolean = false;
	private icons = Icon;

	private get hasContentRight(): boolean {
		return !!this.$slots['content-right'];
	}

	private get hasContentExpander(): boolean {
		return !!this.$slots['content-expander'];
	}

}
